import { render, staticRenderFns } from "./personelReciever.vue?vue&type=template&id=55dd5e43&scoped=true&"
import script from "./personelReciever.vue?vue&type=script&lang=js&"
export * from "./personelReciever.vue?vue&type=script&lang=js&"
import style0 from "./personelReciever.vue?vue&type=style&index=0&id=55dd5e43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd5e43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VDataTable,VIcon,VSpacer})
